import { styled } from "@mui/material/styles";
import { useCallback, useRef } from "react";

import CenteredLayout from "../../components/Centered";
import CopyButton from "./CopyButton";

const Main = styled("main")({
  padding: "30px 0",
});

const CodeContainer = styled("div")({
  display: "flex",
  alignItems: "center",
});

const CodeInput = styled("input")({
  border: "2px solid #7d54d8",
  padding: 7,
  minWidth: 400,
  borderRadius: "5px",
  backgroundColor: "#ededed",
});

function handleValueUpdate() {}

function CliLogin() {
  const inputRef = useRef<HTMLInputElement>(null);
  const handleFocus = useCallback(() => {
    if (inputRef.current) {
      inputRef.current.select();
    }
  }, [inputRef]);
  const { code, state } = Object.fromEntries(
    new URLSearchParams(window.location.search),
  );
  const finalCode = `${state}:${code}`;

  if (!code || !state) {
    return <CenteredLayout>An error occurred...</CenteredLayout>;
  }
  return (
    <CenteredLayout>
      <div>
        <Main>
          Copy this code, switch to your terminal and paste it there:
          <CodeContainer>
            <CodeInput
              ref={inputRef}
              onFocus={handleFocus}
              value={finalCode}
              onChange={handleValueUpdate}
            />
            <CopyButton handleCopyEvent={true} text={finalCode} />
          </CodeContainer>
        </Main>
      </div>
    </CenteredLayout>
  );
}

export default CliLogin;
